import React, { FC, useState, useRef } from "react";
import classNames from "classnames";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Globe } from "@app/components/common/icons";
import { useOutsideClick } from "@app/hooks";
import { LANGUAGE_LABELS } from "./constants";

export const LanguageSwitcher: FC = () => {
  const { languages, language, originalPath, changeLanguage } = useI18next();
  const [isOpen, setIsOpen] = useState(false);
  const mobileDropdownRef = useRef(null);

  useOutsideClick(mobileDropdownRef, () => setIsOpen(false));

  const onToggleLanguageDropdown = () => setIsOpen(!isOpen);

  return (
    <>
      <button
        className="my-5 flex items-center gap-2.5"
        onClick={onToggleLanguageDropdown}
      >
        <Globe className="stroke-base-content h-6 w-6" />
        <span className="capitalize">{language}</span>
      </button>
      <ul
        className={classNames(
          "absolute -right-4 -bottom-4 -left-4 flex flex-col gap-y-5 rounded-t-sm px-5 py-6",
          "bg-nav text-regular text-base-content duration-300",
          "lg:-bottom-7.5",
          isOpen ? "translate-y-0" : "translate-y-full",
        )}
        ref={mobileDropdownRef}
      >
        {languages
          .filter((lang) => lang !== language)
          .map((lang) => (
            <li
              key={lang}
              onClick={() => {
                changeLanguage(lang, originalPath);
                setIsOpen(!isOpen);
              }}
            >
              <div className="group flex cursor-pointer items-center gap-x-3 p-0">
                <img
                  src={LANGUAGE_LABELS[lang.toUpperCase()].icon}
                  alt={`${LANGUAGE_LABELS[lang.toUpperCase()].label} icon`}
                  className="h-5 w-5 rounded-full shadow-sm"
                />
                <span className="group-hover:text-base-content/50 duration-300">
                  {LANGUAGE_LABELS[lang.toUpperCase()].label}
                </span>
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};
